import { useMsal } from '@azure/msal-react';

const Login = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    const spinner = document.getElementById('login-loading-spinner');
    if (spinner) spinner.style.display = 'flex';
    instance.loginRedirect();
  };

  return (
    <div className="login-fancy-bg">
      <div className="login-card">
        <div className="login-illustration">
          <img src="https://cdn.jsdelivr.net/gh/microsoft/fluentui-emoji/assets/Cloud/Cloud_3d.png" alt="Cloud" onError={(e) => {
            e.target.style.display = 'none';
          }} />
        </div>
        <div className="login-content">
          <h1 className="login-title">Trust Tech Scan Studio</h1>
          <p className="login-subtitle">Welcome! Sign in securely with Microsoft Entra ID to access your dashboard.</p>
          <button className="login-btn" onClick={handleLogin}>
            <span className="login-btn-icon"><i className="bi bi-box-arrow-in-right"></i></span>
            Sign in with Microsoft
          </button>
          <div className="login-loading" style={{display: 'none'}} id="login-loading-spinner">
            <div className="spinner"></div>
            <span>Loading...</span>
          </div>
        </div>
      </div>
      {/* <footer className="login-footer">&copy; {new Date().getFullYear()} Trust Tech Scan Studio</footer> */}
    </div>
  );
};

export default Login;
